import React from 'react';
import { Select } from 'antd';
import styled from 'styled-components';
const { Option } = Select;
interface IProps {
  placeholder: string;
  onChange?: (val: string) => void;
  value: string;
  defaultLang?: string;
  data: any;
  defaultValue: string;
}

const SelectReset = (props: IProps) => {
  const selectChange = (value: any) => {
    props.onChange && props.onChange(value);
  };
  return (
    <>
      <Wrapper>
        {props.value && <span className="title">{props.placeholder}</span>}
        <Select
          defaultValue={props.defaultValue}
          className="selected"
          value={props.value}
          onChange={selectChange}
          placeholder={props.placeholder}
          bordered={false}>
          {props.data.map((item: any) => (
            <Option key={item.id} value={item.value}>
              {props.defaultLang === 'EN' ? item.enName : item.localName}
            </Option>
          ))}
        </Select>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  height: 90px;
  //border-bottom: 1px solid #cfd2e3;
  position: relative;
  .title {
    position: absolute;
    left: 11px;
    top: 11px;
    color: #b7bacb;
    font-size: 14px !important;
  }
  .selected {
    width: 100%;
    height: 44px;
    margin: 20px auto 0 !important;
    color: #141c30 !important;
    font-size: 14px;
    border-bottom: 1px solid #cfd2e3;
  }
  .selected::placeholder {
    color: #b7bacb;
    font-size: 14px;
    opacity: 1 !important;
  }
  .ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 46px;
  }
`;

export default SelectReset;
